// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3dq3M","legacyBtn":"MutateMid_legacyBtn__1cALG"};